import { h } from '../../content/pragma.mjs';

const InfoBarComponent = ({ id, variant, inverse, closable, icon }) => {

    return (
        <div>
            <gov-infobar id={`infobar-${id}`} inverse={inverse} variant={variant} closable={closable}>
                {icon && (<gov-icon type={icon.type} name={icon.name} slot="icon"></gov-icon>)}
                <p id={`InfoBarComponentP-${id}`}></p>
            </gov-infobar>
        </div>
    );
};

export { InfoBarComponent };
